import { useState } from 'react';
import { Box } from '@mui/material';

import { FormResetPassword, MessageRecovery } from 'components/authentication/resetPassword';
import BackgroundResetPassword from '../assets/authentication/BackgroundResetPassword.svg';

export const ResetPasswordPage = () => {
    const [send, setSend] = useState(false);

    const sendEmail = () => setSend(!send);

    return (
        <Box
            sx={{
                background: `#182D55 url(${BackgroundResetPassword}) no-repeat center`,
                backgroundSize: 'cover',
                display: 'flex',
                height: '100vh',
                overflow: 'hidden',
                width: '100vw'
            }}>
            {!send ? <FormResetPassword sendEmail={sendEmail} /> : <MessageRecovery goBack={sendEmail} />}
        </Box>
    );
};
